export const productCategory: any = [
	// {key: "G1", label: "아시아"},
	// {key: "G2", label: "유럽"},
	// {key: "G3", label: "기타"},
	{key: "G1", label: "All"},
	{key: "G2", label: "일본"},
	{key: "G3", label: "미주"},
	{key: "G4", label: "유럽"},
	{key: "G5", label: "아시아"},
	{key: "G6", label: "기타"},
	{key: "G7", label: "국내[SELF]"},
	{key: "G8", label: "해외[SELF]"},
	// {key: "G9", label: "호주"},
	// {key: "G10", label: "유럽"},
];